import { forwardRef, Ref } from 'react';
import { IMaskInput } from 'react-imask';

type MaskInputProps = {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    [key: string]: unknown;
};

export function buildSmartDrLegacySiteIdMaskInput(mask: any, lazy = false) {
    const input = forwardRef((props: MaskInputProps, ref: Ref<HTMLInputElement>) => {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask={mask}
                definitions={{ 0: /[0123456789ABCDEFGHKMNPQRSTUVWXYZ]/ }}
                placeholderChar={'\u2000'}
                lazy={lazy}
                inputRef={ref}
                prepareChar={str => str.toUpperCase()}
                onAccept={value => onChange({ target: { name: props.name, value } })}
                overwrite
            />
        );
    });
    input.displayName = 'SmartDrLegavySiteIdMaskInput';

    return input;
}
